export function DashboardSkeleton() {
  return (
    <div className='min-h-screen bg-background py-8'>
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        {/* Header Skeleton */}
        <div className='mb-8'>
          <div className='h-9 bg-muted rounded w-72 animate-pulse mb-2' />
          <div className='h-5 bg-muted rounded w-48 animate-pulse' />
        </div>

        {/* Stats Cards Skeleton */}
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8'>
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className='surface-card rounded-[var(--radius-lg)] p-6'
            >
              <div className='flex items-center gap-4'>
                <div className='w-12 h-12 bg-muted rounded-lg animate-pulse' />
                <div className='flex-1'>
                  <div className='h-4 bg-muted rounded w-20 animate-pulse mb-2' />
                  <div className='h-8 bg-muted rounded w-12 animate-pulse' />
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content Grid Skeleton */}
        <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
          {/* Main Section */}
          <div className='lg:col-span-2 surface-card rounded-[var(--radius-lg)] p-6'>
            <div className='h-7 bg-muted rounded w-48 animate-pulse mb-4' />
            <div className='space-y-4'>
              {[1, 2, 3].map((i) => (
                <div key={i} className='h-20 bg-muted rounded animate-pulse' />
              ))}
            </div>
          </div>

          {/* Sidebar */}
          <div className='surface-card rounded-[var(--radius-lg)] p-6'>
            <div className='h-7 bg-muted rounded w-32 animate-pulse mb-4' />
            <div className='space-y-3'>
              {[1, 2, 3].map((i) => (
                <div key={i} className='h-12 bg-muted rounded animate-pulse' />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
